import { addLocation } from '../../../actions/siteadmin/Location/addLocation';
import { updateLocation } from '../../../actions/siteadmin/Location/updateLocation';
import showToaster from '../../../helpers/toastrMessgaes/showToaster'
import { demoRestriction } from '../../../actions/demoRestriction';

async function submit(values, dispatch) {

    const isRestrict = await dispatch(demoRestriction({ restrictType: 'location', restrictValue: values?.id }));
	if (isRestrict) return;
    
    if (!values?.path) {
        showToaster({ messageId: 'selectLoc', toasterType: 'error' });
        return false;
    }
    if (values?.id) {
        await dispatch(
            updateLocation(
                values.locationName,
                JSON.stringify(values.path),
                values.id,
                values.description,
                values.isActive,
            )
        )
    } else {
        await dispatch(
            addLocation(
                values.locationName,
                JSON.stringify(values.path),
                values.description
            )
        )
    }
}

export default submit;